import React from 'react';
import AppDashboard from './components';
import Layout from '../../layouts/index';

const Dashboard = () => {
    return (
        <Layout>
            <AppDashboard />
        </Layout>
    );
};

export default Dashboard;
